<script>
import { MarkerClusterer, DefaultRenderer } from '@googlemaps/markerclusterer'

class ClusterRenderer extends DefaultRenderer {
  constructor(gmapApi) {
    console.log('views.gmap-cluster.cluster-rederer.constructor')

    super()
    this.gmapApi = gmapApi
  }

  render({ count, position }) {
    // use d3-interpolateRgb to interpolate between red and blue
    // const color = this.palette(count / stats.clusters.markers.max)
    const color = '#AFB42B'

    // Create svg url with fill color.
    const svg = window.btoa(`
  <svg fill="${color}" stroke="#FFFFFF" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
    <circle cx="120" cy="120" opacity="1" r="70" />
  </svg>`)

    // Create cluster marker using svg icon.
    // Note opacity on both label and icon has been removed.
    return new this.gmapApi.maps.Marker({
      position,
      icon: {
        url: `data:image/svg+xml;base64,${svg}`,
        scaledSize: new this.gmapApi.maps.Size(75, 75),
      },
      label: {
        text: String(count),
        color: 'rgba(255,255,255,1)',
        fontSize: '12px',
        fontWeight: 'bold',
      },
      // Adjust zIndex to be above other markers
      zIndex: Number(this.gmapApi.maps.Marker.MAX_ZINDEX) + count,
    })
  }
}

// TODO relay of marker click...
export default {
  data: () => ({
    clusterPromiseResolveFn: null,
    cluster: null,
  }),
  inject: ['mapPromise'],
  provide: function () {
    console.log('views.gmap-cluster.provide')
    const clusterPromise = new Promise((resolve) => {
      this.clusterPromiseResolveFn = resolve
    })
    return { clusterPromise: clusterPromise }
  },

  created: async function () {
    // console.log('components.gmap-cluster.created')
    const gmap = await this.mapPromise

    this.cluster = new MarkerClusterer({
      map: gmap,
      renderer: new ClusterRenderer(this.$gmap),
    })
    this.clusterPromiseResolveFn(this.cluster)

    // console.log('components.gmap-cluster.created.cluster', this.cluster)
  },
  render: function (h) {
    // console.log('components.gmap-cluster.render')
    const self = this
    return h(
      'div',
      {
        on: {
          // Re-emit click event.
          click: function (e) {
            console.log('components.gmap-cluster.render.on-click', e)
            self.$emit('click', e)
          },
        },
      },
      this.$slots.default
    )
  },
}
</script>
